import { render, staticRenderFns } from "./WithdrawPage.vue?vue&type=template&id=5f43f3fc&scoped=true&"
import script from "./WithdrawPage.vue?vue&type=script&lang=js&"
export * from "./WithdrawPage.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawPage.vue?vue&type=style&index=0&id=5f43f3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f43f3fc",
  null
  
)

export default component.exports